// extracted by mini-css-extract-plugin
export var container = "SignUpForm-module__container___ocpvJ";
export var or = "SignUpForm-module__or___Kpug3";
export var button = "SignUpForm-module__button___M01Ve";
export var header = "SignUpForm-module__header___YBkBn";
export var create = "SignUpForm-module__create____xRcw";
export var content = "SignUpForm-module__content___U8HTr";
export var form = "SignUpForm-module__form___wdXD3";